export default "__VITE_ASSET__DZbEiSRk__"